import axios from 'axios';
import apiConfig from '../../api.config';
import constants from '../../../constants';
import storage from '../../../storage';

export default function findHotelInvoiceByInvoiceId({ hotelId, invoiceId }) {
  const {
    host,
    URIs: { findHotelInvoiceByInvoiceId },
  } = apiConfig;

  const uri = `${host}${findHotelInvoiceByInvoiceId}`.replace(':hotelInvoiceId', invoiceId);

  const storedCredentials = JSON.parse(storage.get(constants.AUTH.USER_KEY));
  
  return axios
    .post(uri, {
      data: {
        hotelId: hotelId || 0,
        hotelReference: 'civitfun',
        accessToken: storedCredentials.accessToken,
      },
    })
    .then(res => {
      return res.data;
    });
}
